export var IdNetwork;
(function (IdNetwork) {
    IdNetwork["Core"] = "Core";
    IdNetwork["Chat"] = "Chat";
    IdNetwork["Notification"] = "Notification";
})(IdNetwork || (IdNetwork = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/network/IdNetwork.ts
// module id = 545
// module chunks = 3